<template>
  <div>
    <div class="header profile" />
    <div class="container">
      <div class="profile-header">
        <h2 class="subtitle is-marginless text color-red">
          Legal
        </h2>
        <h1 class="title is-1 text color-white">
          Privacy policy
        </h1>
      </div>
      <div class="box is-large">
        <h2 class="title is-2">
          Sub-title 1
        </h2>

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam finibus ultrices metus, dapibus elementum nunc. Morbi faucibus venenatis neque, id lobortis leo faucibus ut. Praesent ac libero tincidunt eros egestas tempus vel nec magna. Nullam tincidunt, diam at maximus hendrerit, justo lacus dignissim mauris, sed ultrices mauris magna quis velit. Cras scelerisque faucibus ipsum, sit amet pulvinar ipsum commodo a. Sed pharetra erat a mauris congue, hendrerit blandit libero convallis. Suspendisse tempus elementum lorem vel cursus. Integer molestie nibh dui, gravida congue massa congue non. Sed suscipit tortor ac tellus volutpat sodales. Integer eget luctus tellus. Aliquam erat volutpat. Mauris libero massa, molestie eget purus a, eleifend scelerisque velit. In consequat dapibus felis, in vulputate augue lobortis vitae. Integer suscipit porta erat, vel pretium urna sagittis non. Quisque et maximus lorem. Cras feugiat nec lectus ut gravida.
        </p>

        <h2 class="title is-2">
          Sub-title 2
        </h2>

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam finibus ultrices metus, dapibus elementum nunc. Morbi faucibus venenatis neque, id lobortis leo faucibus ut. Praesent ac libero tincidunt eros egestas tempus vel nec magna. Nullam tincidunt, diam at maximus hendrerit, justo lacus dignissim mauris, sed ultrices mauris magna quis velit. Cras scelerisque faucibus ipsum, sit amet pulvinar ipsum commodo a. Sed pharetra erat a mauris congue, hendrerit blandit libero convallis. Suspendisse tempus elementum lorem vel cursus. Integer molestie nibh dui, gravida congue massa congue non. Sed suscipit tortor ac tellus volutpat sodales. Integer eget luctus tellus. Aliquam erat volutpat. Mauris libero massa, molestie eget purus a, eleifend scelerisque velit. In consequat dapibus felis, in vulputate augue lobortis vitae. Integer suscipit porta erat, vel pretium urna sagittis non. Quisque et maximus lorem. Cras feugiat nec lectus ut gravida.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',

  metaInfo: {
    title: 'Privacy policy'
  }
}
</script>

<style>

</style>
